"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
const _excluded = ["title", "description"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
const shareapple = _ref => {
  let {
      title,
      description
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? "title-shareapple" : '') + (description ? " desc-shareapple" : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-shareapple"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-shareapple"
  }, description), /*#__PURE__*/_react.default.createElement("g", {
    clipPath: "url(#appleShareIcon)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M6.75 7.5a.75.75 0 0 1 .102 1.493L6.75 9h-1.5a.75.75 0 0 0-.743.648L4.5 9.75v12c0 .38.282.694.648.743l.102.007h13.5a.75.75 0 0 0 .743-.648l.007-.102v-12a.75.75 0 0 0-.648-.743L18.75 9h-1.5a.75.75 0 0 1-.102-1.493l.102-.007h1.5a2.25 2.25 0 0 1 2.245 2.096L21 9.75v12a2.25 2.25 0 0 1-2.096 2.245L18.75 24H5.25a2.25 2.25 0 0 1-2.245-2.096L3 21.75v-12a2.25 2.25 0 0 1 2.096-2.245L5.25 7.5h1.5ZM12.006 0l.096.007.083.016.106.035.069.034.098.064.072.064 3.75 3.75a.75.75 0 0 1-.976 1.133l-.084-.073-2.47-2.469v8.689a.75.75 0 0 1-1.493.102l-.007-.102V2.561l-2.47 2.47a.75.75 0 0 1-.976.072L7.72 5.03a.75.75 0 0 1-.073-.976l.073-.084L11.47.22a.752.752 0 0 1 .119-.097l.09-.05.103-.04a.741.741 0 0 1 .143-.03l.08-.003Z",
    fill: "#000"
  })), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", null, /*#__PURE__*/_react.default.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  }))));
};
var _default = exports.default = shareapple;